<template>

</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import router from '@/router'
  import store from '@/store'
  import VueCookies from 'vue-cookies'

  Vue.use(VueCookies)

  export default {
    name: 'logout',
    async mounted() {
      // The cookie must survive this call - it is how the server identifies the session to revoke.
      try {
        await axios.post('/auth/logout')
      } catch (error) {
        // Fall through: clearing local state still logs the user out of this browser.
      }

      this.$cookies.remove(".jwt", "/")
      store.commit('LOGOUT_USER')
      router.push('login')
    }
  }
</script>



// WEBPACK FOOTER //
// src/auth/Logout.vue